import { ChevronRight } from 'lucide-react'
import type { ReactNode } from 'react'

import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible'

/** The carrier's own words, folded away under the reason the customer was given. */
export function RawCarrierError({ children }: { children: ReactNode }) {
  return (
    <Collapsible className="group/raw-error flex min-w-0 flex-col gap-2">
      <CollapsibleTrigger className="text-muted-foreground flex cursor-pointer items-center gap-1 self-start text-sm font-medium">
        <ChevronRight className="size-4 transition-transform duration-200 group-data-[state=open]/raw-error:rotate-90" />
        Raw carrier error
      </CollapsibleTrigger>
      <CollapsibleContent>{children}</CollapsibleContent>
    </Collapsible>
  )
}
